var React = require('react');

function HeartInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.579 4.5A3.921 3.921 0 0 1 15.5 8.421c0 2.187-.876 3.284-4.593 6.174l-1.69 1.315a1.167 1.167 0 0 1-1.433 0l-1.691-1.315C2.376 11.705 1.5 10.608 1.5 8.421A3.921 3.921 0 0 1 5.421 4.5c1.16 0 2.191.546 3.079 1.603.888-1.057 1.919-1.603 3.079-1.603Z","fill":"#FF3347"}));
}

HeartInline.defaultProps = {"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none"};

module.exports = HeartInline;

HeartInline.default = HeartInline;
